// test1555
(1555 && 0);
